/**
 * Tela de abertura (#boot, no index.html): aparece antes de qualquer JavaScript,
 * igual à splash nativa. Enquanto ela está na tela, o OTA confere e aplica atualizações.
 */
import lottie from 'lottie-web/build/player/lottie_light.min.js';
import animationData from './boot-anim.json';

const $ = (sel) => document.querySelector(`#boot ${sel}`);
let checkingTimer;
let hiding = false;
const startedAt = Date.now();
const MIN_MS = 2000; // tempo mínimo na tela para a animação do logo terminar

// Logo animado (Lottie): o TC entra, depois as letras de "TicketCar". Fica no último quadro.
const animEl = $('.boot-anim');
if (animEl) {
  const anim = lottie.loadAnimation({ container: animEl, renderer: 'svg', loop: false, autoplay: true, animationData });
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) anim.goToAndStop(anim.totalFrames - 1, true);
  else anim.setSpeed(1.35);
}

export const boot = {
  /** Versão no rodapé (útil em DEV para conferir o OTA). */
  version(text) {
    const el = $('.boot-version');
    if (el) el.textContent = text;
  },

  /** "Verificando atualizações..." só se demorar (evita piscar quando a resposta é rápida). */
  checking() {
    clearTimeout(checkingTimer);
    checkingTimer = setTimeout(() => {
      const s = $('.boot-status');
      if (s) s.innerHTML = '<div class="boot-checking"><span class="boot-spin"></span>Verificando atualizações...</div>';
    }, 400);
  },

  /** Barra de progresso do download. */
  progress(percent, { from, to, env, totalBytes } = {}) {
    clearTimeout(checkingTimer);
    const s = $('.boot-status');
    if (!s) return;
    if (!s.querySelector('.boot-bar')) {
      s.innerHTML = `
        <div class="boot-upd">
          <p class="boot-title">Atualizando o app</p>
          <div class="boot-bar"><div></div></div>
          <div class="boot-row"><span class="boot-detail"></span><strong class="boot-pct"></strong></div>
          <p class="boot-sub">Não feche o app. Leva só alguns segundos.</p>
        </div>`;
      if (from && to) this.version(`${from} → ${to}${env && env !== 'prd' ? ` · ${env.toUpperCase()}` : ''}`);
    }
    const pct = Math.max(0, Math.min(100, Math.round(percent)));
    s.querySelector('.boot-bar div').style.width = `${pct}%`;
    s.querySelector('.boot-pct').textContent = `${pct}%`;
    s.querySelector('.boot-detail').textContent = totalBytes
      ? `Baixando · ${kb((totalBytes * pct) / 100)} de ${kb(totalBytes)}`
      : 'Baixando';
  },

  /** Download concluído: descompactando/conferindo e reiniciando. */
  installing() {
    const s = $('.boot-status');
    if (!s?.querySelector('.boot-bar')) this.progress(100);
    s.querySelector('.boot-title').textContent = 'Quase pronto';
    s.querySelector('.boot-bar div').style.width = '100%';
    s.querySelector('.boot-pct').textContent = '100%';
    s.querySelector('.boot-detail').textContent = 'Instalando a nova versão';
    s.querySelector('.boot-sub').textContent = 'O app vai reabrir sozinho.';
  },

  /** Some com uma transição curta e sai do DOM. */
  hide() {
    clearTimeout(checkingTimer);
    if (hiding) return;
    hiding = true;
    setTimeout(
      () => {
        const boot = document.getElementById('boot');
        if (!boot) return;
        boot.classList.add('boot-out');
        setTimeout(() => boot.remove(), 300);
      },
      Math.max(0, MIN_MS - (Date.now() - startedAt)),
    );
  },
};

const kb = (bytes) => (bytes >= 1024 * 1024 ? `${(bytes / 1024 / 1024).toFixed(1)} MB` : `${Math.round(bytes / 1024)} KB`);
